import React, { useRef, useState } from 'react';

import { useTranslation } from 'react-i18next';
import Image from "next/legacy/image";

import Camera from "@app/components/icons/camera";
import { Close } from "@app/components/icons/close";
import { Button } from '@app/shadcn/components/ui/button';
import cn from 'classnames';


interface IUploadLogo {
    className?: string;
    logoImageUrl?: string;
    onUpload?: (file: File) => void;
    onRemove?: () => void;
    showRemove?: boolean;
    dropdownTopPosition?: number;
}

const UploadLogo = ({ className, onUpload, onRemove, logoImageUrl, showRemove = true, dropdownTopPosition = 116 }: IUploadLogo) => {
    const [showDropdown, setShowDropdown] = useState(false);
    const [logoUrl, setLogoUrl] = useState<string | null>(null);
    const logoRef = useRef<HTMLInputElement | null>(null);
    const { t } = useTranslation();

    React.useEffect(() => {
        if (logoImageUrl) {
            setLogoUrl(logoImageUrl);
        }
    }, []);

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const selectedFile = event.target.files && event.target.files[0];
        if (selectedFile) {
            setLogoUrl(URL.createObjectURL(selectedFile));
            onUpload && onUpload(selectedFile);
        }
    };
    const onRemoveLogo = () => {
        setShowDropdown(false);
        setLogoUrl(null);
        if (logoRef.current) {
            logoRef.current.value = '';
        }
        onRemove && onRemove();
    };

    return (
        <div className={`relative z-50  ${className}`}>
            <div className={cn('rounded-lg w-[72px] h-[72px] flex flex-col justify-center items-center gap-1 cursor-pointer hover:ring-1 hover:ring-black-400', logoUrl ? '' : 'bg-black-900')} onClick={() => setShowDropdown(!showDropdown)}>
                <input ref={logoRef} id="form_logo" type="file" hidden onChange={handleFileChange} />
                {logoUrl ? (
                    <Image height={72} width={72} objectFit="cover" src={logoUrl} alt="logo" className="rounded-image hover:bg-black-100" />
                ) : (
                    <>
                        <Camera className="text-white!" />
                        <h1 className="p4-new text-white!">{t('WORKSPACE.SETTINGS.DETAILS.ADD_LOGO')}</h1>
                    </>
                )}
            </div>
            {showDropdown && (
                <div
                    className={`flex flex-col absolute z-40 shadow-large border border-black-300 h-auto w-full sm:w-[330px] bg-white p-4 rounded gap-2`}
                    style={{
                        top: dropdownTopPosition
                    }}
                >
                    <div className="flex justify-between font-semibold! mb-4">
                        <h1 className="body1 text-black-900">{t('STAFF.WORKSPACE.LOGO')}</h1>
                        <Close
                            onClick={() => {
                                setShowDropdown(false);
                            }}
                            className="top-2 right-2 cursor-pointer p-2 h-8 w-8"
                        />
                    </div>
                    <label onClick={() => logoRef.current?.click()} className="w-full rounded py-3 px-4 h-[36px] body4 bg-black-900 font-semibold hover:opacity-80 flex justify-center items-center">
                        <span className="text-black-100 text-xs sm:text-sm">{t('LOGO.UPDATE')}</span>
                    </label>
                    {showRemove && (
                        <Button className="text-black-900! font-semibold bg-black-300! hover:bg-black-400! " onClick={onRemoveLogo}>
                            {t('LOGO.REMOVE')}
                        </Button>
                    )}
                </div>
            )}
        </div>
    );
};

export default UploadLogo;
